export default __webpack_public_path__ + "assets/967cd72a1b0d7c4bebd75577c6be6190.png";